module.exports = __webpack_public_path__ + "static/media/uconnect-white.8bf7bd66.png";